export const selectPosterState = (state) => state.posters;
